module.exports = __webpack_public_path__ + "img/icon_down_hover.3743ee84.svg";